import React from 'react';

interface SimpleShinyTextProps {
  text: string;
  speed?: number;
  disabled?: boolean;
  className?: string;
}

const SimpleShinyText: React.FC<SimpleShinyTextProps> = ({ 
  text, 
  speed = 5, 
  disabled = false,
  className = ''
}) => {
  const animationDuration = `${speed}s`;
  
  const shinyStyle = {
    color: disabled ? '#ffffff' : '#b5b5b5a4',
    background: disabled 
      ? 'none'
      : 'linear-gradient(120deg, rgba(255, 255, 255, 0) 40%, rgba(255, 255, 255, 0.8) 50%, rgba(255, 255, 255, 0) 60%)',
    backgroundSize: '200% 100%',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    display: 'inline-block',
    animation: disabled ? 'none' : `shine ${animationDuration} linear infinite`,
    fontSize: 'clamp(1rem, 3vw, 2.5rem)',
    fontWeight: 700,
  };

  return (
    <>
      <style>
        {`
          @keyframes shine {
            0% { background-position: 100%; }
            100% { background-position: -100%; }
          }
        `}
      </style>
      <div
        className={`shiny-text ${disabled ? 'disabled' : ''} ${className}`}
        style={shinyStyle}
      >
        {text}
      </div>
    </>
  );
};

export default SimpleShinyText;